var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-provider-alert-container",on:{"click":_vm.close}},[_c('div',{staticClass:"alert-container"},[_c('span',{staticClass:"material-icons-outlined add-provider-alert-icon"},[_vm._v("check_circle")]),_c('h1',{staticClass:"add-provider-alert-title"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }